import { Component, effect, inject, input, signal } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { firstValueFrom } from 'rxjs';
import { UserService } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-user-qr-pin',
  templateUrl: './user-qr-pin.component.html',
  styleUrls: ['./user-qr-pin.component.scss'],
})
export class UserQrPinComponent {
  private readonly userService = inject(UserService);
  private readonly toastrService = inject(NbToastrService);

  readonly userId = input.required<string>();
  readonly hasQrPin = input(false);
  readonly qrPinCreated = input<string | undefined>(undefined);

  readonly active = signal(false);
  readonly activeSince = signal<string | null>(null);
  readonly generatedPin = signal<string | null>(null);
  readonly busy = signal(false);

  constructor() {
    effect(() => {
      this.active.set(this.hasQrPin());
      this.activeSince.set(this.hasQrPin() ? this.qrPinCreated() ?? null : null);
    });
  }

  async generate(): Promise<void> {
    this.busy.set(true);
    try {
      const result = await firstValueFrom(this.userService.generateQrPin(this.userId()));
      this.generatedPin.set(result.pin);
      this.activeSince.set(result.created);
      this.active.set(true);
    } finally {
      this.busy.set(false);
    }
  }

  async revoke(): Promise<void> {
    this.busy.set(true);
    try {
      await firstValueFrom(this.userService.revokeQrPin(this.userId()));
      this.generatedPin.set(null);
      this.activeSince.set(null);
      this.active.set(false);
      this.toastrService.success('Die QR-PIN wurde widerrufen', 'Widerrufen');
    } finally {
      this.busy.set(false);
    }
  }
}
